// extracted by mini-css-extract-plugin
export default {"mainTitle":"EmptyHolder_mainTitle__PiMe1","subTitle":"EmptyHolder_subTitle__h+Nkz","openButton":"EmptyHolder_openButton__nm1xj","installButton":"EmptyHolder_installButton__cLSwy"};